<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-1/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4 text-center">
                  <logo class="w-32 h-auto mb-6" />
                  <h4 class="mb-4">Войти</h4>
                </div>

                <div>
                  <vs-input
                      name="phone"
                      type="tel"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Логин"
                      v-model="phone"
                      class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('phone') }}</span>

                  <vs-input
                      data-vv-validate-on="blur"
                      v-validate="'required|min:6'"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Пароль"
                      v-model="password"
                      class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                      <router-link to="">Забыли пароль?</router-link>
                  </div>
                  <vs-button :disabled="!validateForm" class="block mx-auto" @click="loginJWT">Войти</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'

export default{
  data() {
    return {
      phone: "",
      password: "",
    }
  },
  components: {
    Logo
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.phone !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      return true
    },
    loginJWT () {

      //if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
          phone: this.phone,
          password: this.password
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => { this.$vs.loading.close() })
        .catch(error => {
          console.log(error);
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Ошибка!',
            text: 'Неправильные данные для входа. Пожалуйста, попробуйте снова.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>